module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"padded\">\n	<table class=\"form-table\">\n		<tr>\n			<td>Общее описание источника</td>\n			<td><control type=\"text\" target=\"item.description\"/></td>\n		</tr>\n		<tr>\n			<td>Знаменатель масштаба исходного материала</td>\n			<td><control type=\"text\" target=\"item.denominator\"/></td>\n		</tr>\n		<tr>\n			<td colspan=\"2\" class=\"source-refsystem\">\n				<button on-click=\"addReferenceSystem\">Добавить координатную основу</button>\n			</td>\n		</tr>\n		<tr>\n			<td colspan=\"2\" class=\"source-citation\">\n				<button on-click=\"addCitation\">Ссылка на описание источника</button>\n			</td>\n		</tr>\n		<tr>\n			<td colspan=\"2\">\n				<div class=\"title\">Пространственно-временные характеристики</div>\n				<div class=\"source-extents\"></div>\n				<div class=\"buttons\"><button on-click=\"addExtent\">Добавить</button></div>\n			</td>\n		</tr>\n	</table>\n</div>\n")
  }
  return __output.join("");

}